import React from "react";
import { Alert, Button, Table } from "react-bootstrap";

/**
 * Card content for sending slot emails and viewing email status.
 */
export default function SendSlotEmailCard({
  selectedDays,
  selectedLocation,
  refreshStatus,
  dataDirty,
  emailSendDateData,
  unslotedMembers,
  slots,
  loading,

  // render helpers from parent
  noDateSelectedPrompt,
  noSlottedStudentsPrompt,

  // callbacks
  onSendRoadTestSlotOrTimeEmailsBulk,
  onCheckEmailDate,
  onCopyStudentEmails,
  onCopyParentEmails,
  onCopyPhoneNumbers,
  onRefreshStatus,
  onSendInitalEmailBulk,
  onSlotSave,
}) {
  if (selectedDays.length === 0) {
    return noDateSelectedPrompt;
  }

  const isRMVOrGranite =
    selectedLocation.includes("RMV Site") ||
    selectedLocation.includes("Braintree - Granite St");

  if (isRMVOrGranite) {
    return (
      <div>
        {refreshStatus ? (
          <Alert variant="success">
            <strong>{refreshStatus}</strong>
          </Alert>
        ) : null}
        {dataDirty ? (
          <div>
            <Alert variant="warning">
              <strong>
                Warning: You did not save updates to either the student
                data above, or the day of the week for the exam. You
                must save the student data prior to sending any emails.
              </strong>
              <br></br>
              <br></br>
              <Button variant="primary" onClick={onSlotSave}>
                {" "}
                Save{" "}
              </Button>
            </Alert>
          </div>
        ) : null}
        <Button
          disabled={dataDirty || loading === true}
          onClick={() => onSendRoadTestSlotOrTimeEmailsBulk(true)}
        >
          {" "}
          Send all Unsent Emails{" "}
        </Button>
        <Button
          disabled={dataDirty || loading === true}
          onClick={onCheckEmailDate}
        >
          {" "}
          Check Email Date{" "}
        </Button>
        <Button
          disabled={dataDirty || loading === true}
          onClick={onCopyStudentEmails}
        >
          {" "}
          Copy All Student Emails to Clipboard{" "}
        </Button>
        <Button
          disabled={dataDirty || loading === true}
          onClick={onCopyParentEmails}
        >
          {" "}
          Copy All Parent Emails to Clipboard{" "}
        </Button>
        <Button
          disabled={dataDirty || loading === true}
          onClick={onCopyPhoneNumbers}
        >
          {" "}
          Copy All Phone Numbers to Clipboard{" "}
        </Button>

        {emailSendDateData.length > 0 ? (
          <div>
            The emails sent out will have a appointment date of:{" "}
            {emailSendDateData}
          </div>
        ) : null}

        <Button
          className="rightBut"
          disabled={dataDirty}
          onClick={onRefreshStatus}
        >
          {" "}
          Refresh Status{" "}
        </Button>
        <br></br>
        <br></br>
        <Table striped bordered hover size="sm">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Inital Email</th>
              <th>Time Email</th>
              <th>Confirmation</th>
              <th>Actions</th>
            </tr>
          </thead>
          {unslotedMembers.length > 0 ? (
            <tbody>
              {unslotedMembers.map((x, index) => {
                return (
                  <tr key={x.timestamp}>
                    <td>{x.fName + " " + x.lName}</td>
                    <td>{x.emailAddress}</td>
                    <td>{x.emailInitalState}</td>
                    <td>{x.emailRoadTestSlotState}</td>
                    <td>{x.emailRoadTestSlotConfirmed}</td>
                    <td>
                      <Button
                        disabled={dataDirty || loading}
                        onClick={() => onSendInitalEmailBulk([x])}
                        size="sm"
                      >
                        Send Inital Email
                      </Button>
                      <Button
                        disabled={
                          dataDirty ||
                          loading ||
                          !x.hasOwnProperty("unslotTime")
                        }
                        onClick={() =>
                          onSendRoadTestSlotOrTimeEmailsBulk(false, [x])
                        }
                        size="sm"
                      >
                        Send{" "}
                        {x.hasOwnProperty("unslotTime")
                          ? x.unslotTime
                          : "MISSING TIME"}{" "}
                        Time Email
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          ) : (
            <div></div>
          )}
        </Table>
      </div>
    );
  }

  // Non-RMV / non-Granite — slotted students view
  if (slots.length === 0) {
    return noSlottedStudentsPrompt;
  }

  return (
    <div>
      {refreshStatus ? (
        <Alert variant="success">
          <strong>{refreshStatus}</strong>
        </Alert>
      ) : null}
      {dataDirty ? (
        <div>
          <Alert variant="warning">
            <strong>
              Warning: You did not save updates to either the
              student data above, or the day of the week for the
              exam. You must save the student data prior to
              sending any emails.
            </strong>
            <br></br>
            <br></br>
            <Button variant="primary" onClick={onSlotSave}>
              {" "}
              Save{" "}
            </Button>
          </Alert>
        </div>
      ) : null}
      <Button
        disabled={dataDirty || loading === true}
        onClick={() => onSendRoadTestSlotOrTimeEmailsBulk(true)}
      >
        {" "}
        Send all Unsent Slot Emails{" "}
      </Button>
      <Button
        disabled={dataDirty || loading === true}
        onClick={onCheckEmailDate}
      >
        {" "}
        Check Email Date{" "}
      </Button>
      <Button
        disabled={dataDirty || loading === true}
        onClick={onCopyStudentEmails}
      >
        {" "}
        Copy All Student Emails to Clipboard{" "}
      </Button>
      <Button
        disabled={dataDirty || loading === true}
        onClick={onCopyParentEmails}
      >
        {" "}
        Copy All Parent Emails to Clipboard{" "}
      </Button>
      <Button
        disabled={dataDirty || loading === true}
        onClick={onCopyPhoneNumbers}
      >
        {" "}
        Copy All Phone Numbers to Clipboard{" "}
      </Button>

      {emailSendDateData.length > 0 ? (
        <div>
          The emails sent out will have a appointment date of:{" "}
          {emailSendDateData}
        </div>
      ) : null}

      <Button
        className="rightBut"
        disabled={dataDirty}
        onClick={onRefreshStatus}
      >
        {" "}
        Refresh Status{" "}
      </Button>
      <br></br>
      <br></br>
      <Table striped bordered hover size="sm">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Weekday</th>
            <th>Time</th>
            <th>Inital Email</th>
            <th>Slot Email</th>
            <th>Confirmation</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {slots
            .filter(
              (x) =>
                Object.keys(x.value).length > 0 &&
                x.value.constructor === Object,
            )
            .map((x, index) => {
              return (
                <tr key={x.slotName}>
                  <td>{x.value.fName + " " + x.value.lName}</td>
                  <td>{x.value.emailAddress}</td>
                  <td>{x.value.weekendDate}</td>
                  <td>{x.value.slot}</td>
                  <td>{x.value.emailInitalState}</td>
                  <td>{x.value.emailRoadTestSlotState}</td>
                  <td>{x.value.emailRoadTestSlotConfirmed}</td>
                  <td>
                    <Button
                      disabled={dataDirty || loading}
                      onClick={() => onSendInitalEmailBulk([x.value])}
                      size="sm"
                    >
                      Send Inital Email
                    </Button>
                    <Button
                      disabled={dataDirty || loading}
                      onClick={() =>
                        onSendRoadTestSlotOrTimeEmailsBulk(true, [x.value])
                      }
                      size="sm"
                    >
                      Send Slot Email
                    </Button>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    </div>
  );
}
